import { MobileNavMenu } from "@/components/MobileNavMenu";
import { MkeLogo } from "@/containers/Layout/MainLayout/MkeLogo";
import { NavMenu } from "@/containers/Layout/MainLayout/NavMenu";
import {
  LogoWrapper,
  NavbarContentWrapper,
  StyledNavbarCol,
  ViperLogoWrapper,
} from "@/containers/Layout/MainLayout/styled";
import { UserMenu } from "@/containers/Layout/MainLayout/UserMenu";
import { ViperLogo } from "@/containers/Layout/MainLayout/ViperLogo";
import { routes } from "@/helpers";
import { useMobileLayout } from "@/hooks/useAppMedia";
import { useMsal } from "@azure/msal-react";
import { Layout, Row, Space } from "antd";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;

export const Navbar = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();

  const user = instance.getActiveAccount();
  const isMobile = useMobileLayout();

  return (
    <Header>
      <NavbarContentWrapper>
        <StyledNavbarCol xs={11}>
          <Space size="small" direction="horizontal">
            <LogoWrapper
              data-test-id="navbar-home"
              onClick={() => navigate(routes.dashboard)}
            >
              <MkeLogo />
            </LogoWrapper>
            {!isMobile && <NavMenu />}
          </Space>
        </StyledNavbarCol>
        <StyledNavbarCol xs={2}>
          <ViperLogoWrapper justify="center">
            <ViperLogo />
          </ViperLogoWrapper>
        </StyledNavbarCol>
        <StyledNavbarCol flex={1} xl={11}>
          {user && (
            <Row justify="end">
              {isMobile ? <MobileNavMenu /> : <UserMenu />}
            </Row>
          )}
        </StyledNavbarCol>
      </NavbarContentWrapper>
    </Header>
  );
};
